import * as React from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { ThemeProviderProps } from 'next-themes/dist/types';

export function ShadcnThemeProvider({
  children,
  theme,
  ...props
}: ThemeProviderProps & { theme: 'light' | 'dark' }) {
  React.useEffect(() => {
    const root = window.document.documentElement;

    root.classList.remove('light', 'dark');

    root.classList.add(theme);
  }, [theme]);

  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
